import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
const getAllwarehouse = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.warehouse.list + `${filter ? '?' + filter : ''}`);

    return data;
};
const GetAllWarehouse = (filter) => {
    return useQuery(['WareHouse',filter], () => getAllwarehouse(filter));

};
// ------------------ Add GetAllWarehouse-------
const addWarehouse = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.warehouse.add, payload);
};
const AddWareHousesMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addWarehouse, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('WareHouse');
            toastMessage('success', 'WareHouse Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Delete Color-------
const deleteWareHouse = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.warehouse.delete + id);
};
const DeleteWareHousesMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteWareHouse, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('WareHouse');
            toastMessage('success', 'WareHouse Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Update Warehouse-------
const updateWarehouse = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.warehouse.update + id, payload);
};
const UpdateWareHousesMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateWarehouse, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('WareHouse');
            toastMessage('success', 'Warehouse Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllWarehouse, AddWareHousesMutation, DeleteWareHousesMutation, UpdateWareHousesMutation };
